"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _dialog = require("@design/ui/dialog");
var _LoginHandoff = _interopRequireDefault(require("./LoginHandoff"));
var _useLoginHandoff2 = require("../../hooks/use-login-handoff");
var _AuthContext = require("../../context/AuthContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ReauthModal(_ref) {
  var isOpen = _ref.isOpen;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    loginWithKey = _useAuthInfo.loginWithKey;
  var _useLoginHandoff = (0, _useLoginHandoff2.useLoginHandoff)({
      onKey: loginWithKey,
      active: isOpen
    }),
    phase = _useLoginHandoff.phase,
    retry = _useLoginHandoff.retry;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
    open: isOpen,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "ReauthModal",
    "data-sentry-source-file": "ReauthModal.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, {
      showCloseButton: false,
      onInteractOutside: function onInteractOutside(event) {
        return event.preventDefault();
      },
      onEscapeKeyDown: function onEscapeKeyDown(event) {
        return event.preventDefault();
      },
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "ReauthModal.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "ReauthModal.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "ReauthModal.tsx",
          children: "Your session expired"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogDescription, {
          "data-sentry-element": "DialogDescription",
          "data-sentry-source-file": "ReauthModal.tsx",
          children: "Signing you in again to continue. Your current work is still here. Once you\u2019re back in, please retry your last action if it did not complete."
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginHandoff.default, {
        phase: phase,
        onRetry: retry,
        "data-sentry-element": "LoginHandoff",
        "data-sentry-source-file": "ReauthModal.tsx"
      })]
    })
  });
}
var _default = exports.default = ReauthModal;